module.exports = __webpack_public_path__ + "img/azure-logo.af995160.png";